exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".client-tab-pane-bf3e2{border:1px solid #e8e8e8;border-top:none;box-sizing:border-box;padding:10px}.clientTabs-58904{background-color:#fff;box-shadow:0 0 3px #ccc;border-radius:4px;margin-bottom:15px;padding:10px}.editableCellStyle-e9d4d{padding-right:24;cursor:pointer;display:block;height:22px}", ""]);

// Exports
exports.locals = {
	"client-tab-pane": "client-tab-pane-bf3e2",
	"clientTabs": "clientTabs-58904",
	"editableCellStyle": "editableCellStyle-e9d4d"
};